import { useNavigate } from 'react-router-dom';
import Button from '../Button';
import './styles/_profile-actions.scss';

interface ProfileActionsProps {
  cancelTo: string;
  onSave?: () => void;
  submit?: boolean;
  isSaving?: boolean;
  isDisabled?: boolean;
}

const ProfileActions = ({
  cancelTo,
  onSave,
  submit = false,
  isSaving = false,
  isDisabled = false
}: ProfileActionsProps) => {
  const navigate = useNavigate();

  return (
    <div className="profile-actions">
      <Button className="profile-actions-cancel-button" onClick={() => navigate(cancelTo)}>
        CANCEL
      </Button>
      {(onSave || submit) && (
        <Button
          className="profile-actions-save-button"
          onClick={onSave}
          submit={submit}
          isDisabled={isDisabled || isSaving}
        >
          {isSaving ? 'SAVING...' : 'SAVE'}
        </Button>
      )}
    </div>
  );
};

export default ProfileActions;
